// extracted by mini-css-extract-plugin
export default {"wrapper":"MapPage_wrapper__ytnuj"};